import * as React from 'react'
import { Pressable, StyleSheet, View } from 'react-native'
import { colors } from './theme'
import { Text } from './Text'
import { spacing } from './types'

interface RadioInputProps {
	label: string
	selected: boolean
	onPress: () => void
	disabled?: boolean
	description?: string
	error?: string
	color?: string
	value?: string
	name?: string
}

export const RadioInput = React.forwardRef<View, RadioInputProps>(
	(
		{
			label,
			selected,
			onPress,
			disabled = false,
			description,
			error,
			color = global.orgColor,
			value,
			name,
		},
		ref
	) => {
		return (
			<Pressable
				onPress={onPress}
				disabled={disabled}
				style={styles.container}
				accessibilityRole="radio"
				accessibilityState={{ checked: selected, disabled }}
			>
				<View
					ref={ref}
					style={[
						styles.radio,
						selected && { borderColor: color },
						disabled && styles.radioDisabled,
						error && styles.radioError,
					]}
				>
					{selected && <View style={[styles.radioInner, { backgroundColor: color }]} />}
				</View>
				<View style={styles.content}>
					<Text
						level="body"
						weight={selected ? 'medium' : 'regular'}
						tone={disabled ? 'secondary' : 'neutral'}
					>
						{label}
					</Text>
					{description && (
						<Text level="small" tone="secondary" style={styles.description}>
							{description}
						</Text>
					)}
					{error && (
						<Text level="small" tone="critical" style={styles.error}>
							{error}
						</Text>
					)}
				</View>
			</Pressable>
		)
	}
)

RadioInput.displayName = 'RadioInput'

const styles = StyleSheet.create({
	container: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: spacing.sm,
	},
	radio: {
		width: 20,
		height: 20,
		borderRadius: 10,
		borderWidth: 2,
		borderColor: colors.gray500,
		alignItems: 'center',
		justifyContent: 'center',
	},
	radioDisabled: {
		borderColor: colors.gray200,
		backgroundColor: colors.gray50,
	},
	radioError: {
		borderColor: colors.red500,
	},
	radioInner: {
		width: 10,
		height: 10,
		borderRadius: 5,
	},
	content: {
		flex: 1,
	},
	description: {
		marginTop: spacing.xs,
	},
	error: {
		marginTop: spacing.xs,
	},
})
